import { Paragraph, tokens } from '@welbe/web-design-system';
import React from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { formatDate } from 'Views/HealthRiskAssessment/HealthRiskAssessment.functions';
import { ActivitiesTypes } from 'Views/HealthRiskAssessment/HealthRiskAssessment.types';
import {
	ActivitiesContainer,
	Container,
	OptionSelector,
} from './LeftSidePanel.styles';

type LeftSidePanelProps = {
	errorIds?: string[];
	focusedActivity: string;
	activities: ActivitiesTypes[];
	onSelectActivity: (id: string) => void;
};

export const LeftSidePanel = ({
	errorIds,
	activities,
	focusedActivity,
	onSelectActivity,
}: LeftSidePanelProps) => {
	const handleSelectSection = (e: React.SyntheticEvent, id: string) => {
		e.stopPropagation();
		onSelectActivity(id);
	};

	return (
		<Container>
			<Paragraph
				fontSize="16px"
				padding="0 0 0 16px"
				fontWeight="600"
				color={tokens.color_primary}
			>
				Actividades
			</Paragraph>
			<ActivitiesContainer>
				{activities.map((activity) => (
					<OptionSelector
						key={activity.settings?.name}
						onClick={(e) => handleSelectSection(e, activity.id)}
						$checked={focusedActivity === activity.id}
						$error={errorIds?.includes(activity.id)}
					>
						<div>
							<Paragraph
								fontSize="18px"
								fontWeight="600"
								elipsis
								title={activity.activityName}
								width="290px"
								color={
									errorIds?.includes(activity.id)
										? tokens.color_toast_error
										: tokens.color_gray_dark
								}
							>
								{activity.activityName}
							</Paragraph>
							<Paragraph fontSize="14px" fontWeight="500">
								{formatDate(activity)}
							</Paragraph>
						</div>
						<FiChevronRight size={28} color={tokens.color_primary} />
					</OptionSelector>
				))}
			</ActivitiesContainer>
		</Container>
	);
};
